// ============================================================================
// WORK ITEM DRAWINGS TAB (Hub)
// Entry point from WorkItemDetailModal — delegates to DrawingWorkItemHub.
// ============================================================================

'use client';

import React from 'react';
import type { WorkItem } from '@/components/UniversalWorkItems';
import DrawingWorkItemHub from '@/components/tabs/DrawingWorkItemHub';

export interface WorkItemDrawingsTabProps {
  workItemId: string;
  workItem: WorkItem;
  isActive: boolean;
  onDrawingsChange?: (count: number) => void;
  readOnly?: boolean;
}

export default function WorkItemDrawingsTab(props: WorkItemDrawingsTabProps) {
  return <DrawingWorkItemHub {...props} />;
}
